(function () {
  'use strict';

  angular.module('app.base', []);

})();